<template>
  <svg xmlns="http://www.w3.org/2000/svg" height="100%" viewBox="0 0 79.919 79.919">
    <path
      d="M22.98,3a2.22,2.22,0,1,1,0,4.44H14.1A6.66,6.66,0,0,0,7.44,14.1v9.018a2.22,2.22,0,1,1-4.44,0V14.1A11.1,11.1,0,0,1,14.1,3ZM62.94,7.44a2.22,2.22,0,0,1,0-4.44h8.88a11.1,11.1,0,0,1,11.1,11.1v8.88a2.22,2.22,0,1,1-4.44,0V14.1a6.66,6.66,0,0,0-6.66-6.66Zm15.54,55.5a2.22,2.22,0,1,1,4.44,0v8.88a11.1,11.1,0,0,1-11.1,11.1H62.94a2.22,2.22,0,1,1,0-4.44h8.88a6.66,6.66,0,0,0,6.66-6.66ZM3,62.94a2.22,2.22,0,0,1,4.44,0v8.88a6.66,6.66,0,0,0,6.66,6.66h8.88a2.22,2.22,0,1,1,0,4.44H14.1A11.1,11.1,0,0,1,3,71.82ZM25.2,27.42a2.22,2.22,0,0,1,4.44,0v4.44a2.22,2.22,0,1,1-4.44,0Zm35.52,0a2.22,2.22,0,0,1,4.44,0v4.44a2.22,2.22,0,1,1-4.44,0Zm-17.76,0a2.22,2.22,0,1,1,4.44,0V45.18a6.66,6.66,0,0,1-6.66,6.66,2.22,2.22,0,1,1,0-4.44,2.22,2.22,0,0,0,2.22-2.22ZM25.644,59.832A2.22,2.22,0,0,1,29.2,57.168c4.045,5.393,8.593,7.992,13.764,7.992s9.719-2.6,13.764-7.992a2.22,2.22,0,1,1,3.552,2.664C55.441,66.278,49.629,69.6,42.96,69.6S30.479,66.278,25.644,59.832Z"
      transform="translate(-3 -3)"
    />
  </svg>
</template>
<script>
export default {
  name: "M4FaceIdSvg"
};
</script>
